import { createAppAsyncThunk } from '@/store/typedAsyncThunk';
import type { ConfirmForgotPasswordRequest, ForgotPasswordRequest, PasswordResetResponse } from './passwordResetTypes';

export const requestPasswordReset = createAppAsyncThunk<PasswordResetResponse, ForgotPasswordRequest>(
  'passwordReset/request',
  async (request, { extra: { config }, rejectWithValue }) => {
    const response = await config.authService.forgotPassword(request);
    if (!response.success) return rejectWithValue(response);
    return response;
  },
);

export const confirmPasswordReset = createAppAsyncThunk<PasswordResetResponse, ConfirmForgotPasswordRequest>(
  'passwordReset/confirm',
  async (request, { extra: { config }, rejectWithValue }) => {
    const response = await config.authService.confirmForgotPassword(request);
    if (!response.success) return rejectWithValue(response);
    return response;
  },
);
